module.exports = __webpack_public_path__ + "static/stjo-1-e5291a99597920c7a883ec1104e63d67.jpg";